export default __webpack_public_path__ + "static/media/img1.74397b07.png";